import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { useColorModeValue } from "@chakra-ui/system";
import Card from "components/card/Card";
import { cloneDeep } from "lodash";
import { Draft } from "models/draft_type";
import { OrderType } from "models/order_type";
import moment from "moment";
import Pagination from "rc-pagination";
import { useEffect, useState } from "react";
import { FaRegFileExcel } from "react-icons/fa";
import { MdCalendarMonth, MdDateRange, MdMail, MdPageview, MdPriceChange, MdPrint, MdVisibility } from "react-icons/md";
import OrderStatus from "./OrderStatus";

interface IOrderTable {
  add: () => void;
  listDraft : Draft[];
  list: OrderType[];
  edit: (item: OrderType) => void;
  editDraft: (item: OrderType) => void;
  deletar: (item: OrderType) => void;
  deleteDraft : (item: OrderType) => void;
  print: (item: OrderType) => void;
  showDelete: boolean;
  cancelRef: any;
  closeDelete: () => void;
  remove: () => void;
  removeDraft: () => void;
  selectedDraft: OrderType;
}

const OrderTable = ({
  add,
  cancelRef,
  closeDelete,
  deletar,
  deleteDraft,
  edit,
  list,
  remove,
  showDelete,
  print,
  listDraft,
  editDraft,
  selectedDraft,
  removeDraft
}: IOrderTable) => {

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  let finalData : OrderType[] = [];
  const countPerPage = 10;
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [collection, setCollection] = useState(
    cloneDeep(finalData.slice(0, countPerPage))
  );

  const updatePage = (p: number) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setCollection(cloneDeep(finalData.slice(from, to)));
  };


  useEffect(() => {
    const joinData = () => {
      const newOrders: OrderType[] = [];
      listDraft.forEach((item) => {
        let ORDER_ITEM : OrderType =  JSON.parse(item.rascunho);
        ORDER_ITEM.id = item.id;
        newOrders.push(ORDER_ITEM);
      });
      finalData = [...list, ...newOrders];
    };
  
    const updatePage = (p: number) => {
      setCurrentPage(p);
      const to = countPerPage * p;
      const from = to - countPerPage;
      setCollection(cloneDeep(finalData.slice(from, to)));
    };
  
    const searchData = (val: any) => {
      const query = val.toLowerCase();
      setCurrentPage(1);
      const filteredData = finalData.filter(item => 
        item?.cliente?.nome.toLowerCase().includes(query) ||
        item?.agencia?.nome.toLowerCase().includes(query) ||
        item?.Usuario?.nome.toLowerCase().includes(query)
      ).slice(0, countPerPage);
      setCollection(filteredData);
    };
  
    joinData();
  
    if (!value) {
      updatePage(1);
    } else {
      searchData(value);
    }
  }, [list,listDraft, value]);
  const pad = (a: any, b: any) =>{
    return(1e15 + a + '').slice(-b);
  }
  return (
    <Card flexDirection="column" overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex
        px="25px"
        mb="16px"
        mt="16px"
        justifyContent="space-between"
        align="center"
      >
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Listagem de Orçamentos
        </Text>
        <Button onClick={add} colorScheme="brand" variant="outline">
          Adicionar
        </Button>
      </Flex>
      <Box px="25px" mb="16px" mt="16px" justifyContent="space-between">
        <Stack direction="row" spacing={4}>
          <Button
            leftIcon={<MdVisibility />}
            colorScheme="brand"
            variant="solid"
          >
            Visão Geral
          </Button>
          <Button leftIcon={<MdMail />} colorScheme="brand" variant="solid">
            Enviar
          </Button>
          <Button
            leftIcon={<MdPrint />}
            colorScheme="brand"
            variant="solid"
          >
            Imprimir
          </Button>
          <Button
            leftIcon={<MdCalendarMonth />}
            colorScheme="brand"
            variant="solid"
          >
            Projeto
          </Button>
          <Button
            leftIcon={<MdDateRange />}
            colorScheme="brand"
            variant="solid"
          >
            Ordem
          </Button>
          <Button
            leftIcon={<MdPageview />}
            colorScheme="brand"
            variant="solid"
          >
            Emitir Contrato
          </Button>
          <Button
            leftIcon={<MdPriceChange />}
            colorScheme="brand"
            variant="solid"
          >
            Relatório
          </Button>
          <Button
            leftIcon={<FaRegFileExcel />}
            colorScheme="brand"
            variant="solid"
          >
            Excel
          </Button>
        </Stack>
      </Box>
      <Box>

      <Stack p={4}>
          <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"

              >
               Buscar
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Buscar"
                fontWeight="500"
                w={320}
                size="md"
                onChange={e => setValue(e.target.value)}
                value={value}
              />
            </FormControl>
          </Stack>
        <Table variant="striped" color="gray.500" mb="24px" mt="12px" id="myTable">
          <Thead>
            <Tr>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #STATUS
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #CÓDIGO
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #CADASTRO
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #EDIÇÃO
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #CLIENTE
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #AGENCIA
                </Flex>
              </Th>

              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #RESPONSÁVEL
                </Flex>
              </Th>
              <Th pe="10px" borderColor={borderColor} cursor="pointer">
                <Flex
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: "10px", lg: "12px" }}
                  color="gray.400"
                >
                  #OPÇÕES
                </Flex>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
             {collection?.map((item, index) => {
              return (
                <Tr key={`${item?.id}-${item?.idEmpresa}-${index}`}>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    <OrderStatus data={item?.status}/>
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item.status !== "0" ?  pad(item.id, 6) : pad(0, 6)}
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {moment(item?.dataCriacao).format("DD/MM/yyyy")}
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {moment(item?.dataEdicao).format("DD/MM/yyyy")}
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item?.cliente?.nome}
                  </Td>

                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item?.agencia?.nome}
                  </Td>
                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    {item?.Usuario?.nome}
                  </Td>

                  <Td fontSize={{ sm: "14px" }} borderColor="transparent">
                    <Button
                      onClick={() => {
                        item.status !== "0" 
                        ? edit(item)
                        : editDraft(item)
                      }}
                      colorScheme="green"
                      variant="ghost"
                    >
                      Editar
                    </Button>
                    <Button
                      onClick={() => {
                        item.status !== "0" 
                        ? deletar(item)
                        : deleteDraft(item);
                      }}
                      colorScheme="red"
                      variant="ghost"
                      ml="1"
                    >
                      Excluir
                    </Button>
                  </Td>
                </Tr>
              );
            })} 
          </Tbody>
        </Table>

        <Pagination
              pageSize={countPerPage}
              onChange={updatePage}
              current={currentPage}
              total={list.length}
              style={{
                float : 'right',
                marginRight :  24
              }}
            />

        <AlertDialog
          isOpen={showDelete}
          leastDestructiveRef={cancelRef}
          onClose={closeDelete}
          isCentered
          motionPreset="slideInBottom"
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Cuidado!
              </AlertDialogHeader>

              <AlertDialogBody>
                Deseja realmente deletar esse registro?
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button
                  ref={cancelRef}
                  onClick={closeDelete}
                  colorScheme={"gray"}
                >
                  Cancelar
                </Button>
                <Button ref={cancelRef} onClick={ selectedDraft !== null ? removeDraft  : remove} colorScheme={"red"}>
                  Excluir
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>
    </Card>
  );
};

export default OrderTable;
